import React, { useState, useEffect, useMemo } from "react"
import { Row, Col, Card, Table, Input } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import Select from "react-select"
import configure from "configure"
import { DatePicker } from "antd"
import NewPagination from "components/Common/Newpagination"
import { Absentees } from "utils/columns/Human Resource/SixMonsLeaveColumn"
import { useSelector } from "react-redux"
import { colourStyles } from "utils/common-options"
import { fetchNodeData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
const { RangePicker } = DatePicker

function TableContainer({ columns, data, filter, setFilter, fetchData }) {
  // Normalize data to ensure it's an array
  const normalizedData = Array.isArray(data) ? data : []
  const generalData = useSelector(state => state?.GeneralData?.generalData)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
  } = useTable(
    {
      columns,
      data: normalizedData,
      initialState: {
        sortBy: [{ id: "year", desc: true }],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize } = state

  useEffect(() => {
    setPageSize(5)
  }, [setPageSize])

  const filterOptions = [
    { label: "Today", value: 1 },
    { label: "Tomorrow", value: 2 },
    { label: "Week", value: 3 },
  ]
  return (
    <Row>
      <Col xl="12">
        <div className="card-body">
          {/* Row 1 — Title */}
          <Row className="mb-2">
            <Col className="text-purple fs-5 fw-bold">Absentees</Col>
          </Row>

          {/* Row 2 — Both selects spaced evenly */}
          <Row className="align-items-center justify-content-between mb-3">
            <Col md="auto">
              <select
                className="border-radius form-select"
                style={{ width: "120px" }}
                value={pageSize}
                onChange={e => setPageSize(e.target.value)}
              >
                {[5, 10, 25, 50, 100].map(p => (
                  <option key={p} value={p}>
                    Show {p}
                  </option>
                ))}
              </select>
            </Col>

            <Col md="auto">
              <select
                className="border-radius form-select"
                style={{ width: "120px" }}
                value={filter.value || 1}
                onChange={e => {
                  const selectedValue = Number(e.target.value)
                  const selectedFilter = filterOptions.find(
                    f => f.value === selectedValue
                  )

                  setFilter(selectedFilter)
                  fetchData(selectedFilter) // 🔥 NEW value sent correctly
                }}
              >
                {filterOptions.map(p => (
                  <option key={p.label} value={p.value}>
                    {p.label}
                  </option>
                ))}
              </select>
            </Col>
          </Row>

          <div className="table-responsive">
            <Table
              className="table table-bordered"
              {...getTableProps()}
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <thead>
                {headerGroups.map((headerGroup, i) => (
                  <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column, index) => (
                      <th
                        key={index}
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        className="text-center"
                        style={{ width: column.width }}
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row)
                  return (
                    <tr
                      key={i}
                      {...row.getRowProps()}
                      style={{
                        backgroundColor:
                          row.original.latepunch == true
                            ? "#fff3f3" // red-ish
                            : row.original.latepunch > 2
                            ? "#ffe8bf52" // orange-ish
                            : "transparent",
                      }}
                    >
                      {row.cells.map((cell, index) => (
                        <td
                          key={index}
                          {...cell.getCellProps()}
                          className="text-center"
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>

          <Row className="d-flex justify-content-between align-items-center flex-wrap py-3 py-md-0">
            <NewPagination
              gotoPage={gotoPage}
              canPreviousPage={canPreviousPage}
              previousPage={previousPage}
              canNextPage={canNextPage}
              pageIndex={pageIndex}
              pageOptions={pageOptions}
              pageSize={pageSize}
              page={page}
              data={normalizedData}
              nextPage={nextPage}
            />
          </Row>
        </div>
      </Col>
    </Row>
  )
}

const TodaysAbsentees = () => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({ label: "Today", value: 1 })

  const mockAbsenteesData = {
    success: true,
    data: [
      {
        staff_id: "EMP001",
        alias_name: "John Doe",
        avatar: "/images/1759823954.png",
        month: "April",
        leaves: 5,
      },
      {
        staff_id: "EMP002",
        alias_name: "Priya Sharma",
        avatar: "/images/1759823954.png",
        month: "May",
        leaves: 3,
      },
      {
        staff_id: "EMP003",
        alias_name: "Ahmed Khan",
        avatar: "/images/1759823954.png",
        month: "June",
        leaves: 2,
      },
      {
        staff_id: "EMP004",
        alias_name: "Sofia Patel",
        avatar: "/images/1759823954.png",
        month: "July",
        leaves: 6,
      },
      {
        staff_id: "EMP005",
        alias_name: "Liam Brown",
        avatar: "/images/1759823954.png",
        month: "August",
        leaves: 1,
      },
      {
        staff_id: "EMP006",
        alias_name: "Aarav Mehta",
        avatar: "/images/1759823954.png",
        month: "September",
        leaves: 4,
      },
    ],
  }

  const fetchData = async filterData => {
    const response = await fetchNodeData(
      setLoading,
      `Absentees/${filterData.value || filter}`,
      secureLocalStorage.getItem("auth_token")
    )

    if (response.success) {
      setData(response.data)
    } else {
      setData([])
    }
  }

  useEffect(() => {
    fetchData(filter)
  }, [])

  // const column1 = useMemo(() => Absentees(), [])
  const dateColumn = {
    Header: "Date",
    accessor: "date",
    className: "text-center",
    width: "20%",
  }

  const column1 = useMemo(() => {
    let baseColumns = Absentees()

    // IF WEEK → Insert Date Column After Name Column
    if (filter.value === 3) {
      return [
        baseColumns[0], // Sr No
        baseColumns[1], // Staff ID
        baseColumns[2], // Name
        dateColumn, // 👈 Insert DATE COLUMN
        baseColumns[3], // Status
      ]
    }

    return baseColumns // For Today & Tomorrow
  }, [filter])

  return (
    <div>
      {isLoading && <Loader />}
      <div className="position-relative">
        <Row>
          <Col lg="12">
            <Card>
              <div className="responsive-table">
                <TableContainer
                  columns={column1}
                  data={data}
                  filter={filter}
                  setFilter={setFilter}
                  fetchData={fetchData}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default TodaysAbsentees
